<template>
  <a-modal
    width="800px"
    title="确认计算结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，
      <span v-if="calculationAbnormal.length" style="color: red;">部分结果异常或有误，建议返回检查</span>
      <span v-else>计算结果如下</span>:
    </div>
    <br>
    <h3>生长性能</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>成活率（%）</span>
          <a-icon v-if="isAbnormal('survivalRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('survivalRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.survivalRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>出栏日龄（天）</span>
          <a-icon v-if="isAbnormal('outAge')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('outAge') ? 'abnormalBox' : 'box'">
            {{calculationResult.outAge?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>耗料量（斤/只）</span>
          <a-icon v-if="isAbnormal('feedCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('feedCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.feedCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>出栏体重（斤/只）</span>
          <a-icon v-if="isAbnormal('avgOutWeight')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgOutWeight') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgOutWeight?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>料重比</span>
          <a-icon v-if="isAbnormal('weightCostRatio')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('weightCostRatio') ? 'abnormalBox' : 'box'">
            {{calculationResult.weightCostRatio?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>日增重（g/只）</span>
          <a-icon v-if="isAbnormal('avgWeightIncrement')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgWeightIncrement') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgWeightIncrement?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>日采食（g/只）</span>
          <a-icon v-if="isAbnormal('avgFeed')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgFeed') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgFeed?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>欧指</span>
          <a-icon v-if="isAbnormal('europeanEfficiencyIndex')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('europeanEfficiencyIndex') ? 'abnormalBox' : 'box'">
            {{calculationResult.europeanEfficiencyIndex?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    <br>
    <h3>经济效益</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>饲料单价（元/吨）</span>
          <a-icon v-if="isAbnormal('feedPrice')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('feedPrice') ? 'abnormalBox' : 'box'">
            {{calculationResult.feedPrice?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>饲料成本（元/只）</span>
          <a-icon v-if="isAbnormal('feedCostPrice')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('feedCostPrice') ? 'abnormalBox' : 'box'">
            {{calculationResult.feedCostPrice?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>单只收益（元/只）</span>
          <a-icon v-if="isAbnormal('hairyChickenEarnings')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('hairyChickenEarnings') ? 'abnormalBox' : 'box'">
            {{calculationResult.hairyChickenEarnings?.toFixed(2) || '-'}}
          </div>
        </a-col><a-col :span="6" >
          <span>净收益（元）</span>
          <a-icon v-if="isAbnormal('pureSaleProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('pureSaleProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.pureSaleProfit?.toFixed(2) || '-'}}
          </div>
        </a-col><a-col :span="6" >
          <span>客户增值（元/只）</span>
          <a-icon v-if="isAbnormal('customerIncrement')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('customerIncrement') ? 'abnormalBox' : 'box'">
            {{calculationResult.customerIncrement?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
export default {
  props:['visible','calculationResult','calculationAbnormal'],
  data(){
    return{}
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('calculationConfirm')
    },
    handleCancel() {
      this.$emit('calculationAbnormalInit')
      this.$emit('isShow', false)
    },
    isAbnormal(value){
      return this.calculationAbnormal.includes(value)
    }
  }
}
</script>

<style lang='scss'>
.result{
  background-color:whitesmoke;
  padding: 3px;
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
  .abnormalBox{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
    color: red;
  }
  .anticon{
    color: orange 
  }
}
</style>